import type { HttpClient } from "@/core/services/protocols/types";
import {
  IAssinaturasContabil,
  IAutoContratacaoMatrizes,
  IAutoContratacaodGateway,
  IAgendamentoParams,
  IPayloadAutoContratar,
  IReturnValidationAutocontratar,
  TEmailConfirmar
} from "./type";
import { IDefaultContabilResponse } from "../types";
import { injectable, inject } from "inversify";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class AutocontratacaoHttpGateway
  implements IAutoContratacaodGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async indexAssinaturas(): Promise<IAssinaturasContabil[]> {
    const response = await this.httpClient.get<
      IDefaultContabilResponse<IAssinaturasContabil[]>
    >({ url: "v1/contabil/auto-contratacao/obter-contratacoes" });

    return response.body?.result || [];
  }

  async confirmarEmail(payload: TEmailConfirmar): Promise<void> {
    await this.httpClient.post<TEmailConfirmar>({
      url: "/v1/contabil/auto-contratacao/confirmar-email",
      body: { ...payload }
    });
  }

  async createAgendamento(params: IAgendamentoParams): Promise<void> {
    await this.httpClient.post({
      url: "/v1/contabil/auto-contratacao/agendar-demonstracao",
      body: { ...params }
    });
  }

  async getMatrizes(): Promise<IAutoContratacaoMatrizes[]> {
    const response = await this.httpClient.get<
      IDefaultContabilResponse<IAutoContratacaoMatrizes[]>
    >({ url: "v1/contabil/auto-contratacao/obter-matrizes" });

    return response.body?.result || [];
  }

  async createAutoContratacao(
    params: IPayloadAutoContratar
  ): Promise<IReturnValidationAutocontratar | undefined> {
    const response = await this.httpClient.post<IReturnValidationAutocontratar>(
      {
        url: "/v1/contabil/auto-contratacao/contratar",
        body: { ...params }
      }
    );

    return response.body;
  }

  async indexCertificadosPendentes(
    params: IAutoContratacaoMatrizes[]
  ): Promise<IReturnValidationAutocontratar | undefined> {
    const response = await this.httpClient.post<IReturnValidationAutocontratar>(
      {
        url: "/v1/contabil/auto-contratacao/verificar-certificados",
        body: { matrizes: params }
      }
    );

    return response.body;
  }
}
